/* eslint-disable @typescript-eslint/no-var-requires */
import React, { useEffect, useRef, useState } from 'react';
import { usePlayFlag } from './../../components/topicScroll';

import ImgPoint from '../../../../../assets/animation_point.gif';

import { Button, Modal } from 'antd';
import './animation019.less';

interface IAnimation019SubItem {
  img: string;
}
interface IAnimation019Item {
  content: string;
  tip?: string;

  subItems?: IAnimation019SubItem[];
}

interface IAnimation019Props {
  items: IAnimation019Item[];
  img: string;
  onCompleted?: () => void;
}

const Animation019: React.FunctionComponent<IAnimation019Props> = ({
  items,
  img,
  onCompleted,
}) => {
  const [palySocialMedia, setPalySocialMedia] = React.useState(1);
  const crrRef = useRef() as React.MutableRefObject<HTMLDivElement>;
  const playFlag = usePlayFlag(crrRef.current as HTMLElement, '.course-body');
  const startPlay = (next = 1) => {
    setPalySocialMedia(next);
    next += 1;
    if (next <= items.length) {
      setTimeout(() => startPlay(next), 2700);
    } else {
      onCompleted && onCompleted();
    }
  };
  useEffect(() => {
    if (playFlag && palySocialMedia <= 1) {
      startPlay();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [playFlag]);

  const clickToPlay = () => {
    if (palySocialMedia <= 1) {
      startPlay();
    }
  };
  const [isModalOpen, setModalOpen] = useState(false);

  const [modalItem, setModalItem] = useState<IAnimation019SubItem[]>();

  const [show, setShow] = useState(true);

  return (
    <div ref={crrRef} className="animation019" onClick={() => clickToPlay()}>
      <img
        className="click-point1"
        onClick={() => clickToPlay()}
        style={{
          display: palySocialMedia <= 1 ? 'block' : 'none',
        }}
        src={ImgPoint}
        alt=""
      />
      <div className="animation019-bg" />
      {items.map((itm: IAnimation019Item, idx: number) => (
        <div
          key={idx}
          className={`animation019-panel s${idx + 1} animation  ${
            palySocialMedia >= idx + 1 ? 'fade-in' : ''
          }`}
        >
          <div
            className="animation019-content"
            dangerouslySetInnerHTML={{ __html: itm.content }}
          >
            {itm.subItems ? (
              <div className="view-more">
                <Button
                  className="view-more-btn"
                  onClick={() => {
                    setModalItem(itm.subItems);
                    setModalOpen(true);
                    setShow(false);
                  }}
                  type="link"
                >
                  {itm.tip}
                  <img
                    className="click-point1"
                    hidden={!show}
                    src={ImgPoint}
                    alt=""
                  />
                </Button>
              </div>
            ) : null}
          </div>
        </div>
      ))}
      {modalItem && (
        <Modal
          width="60%"
          className="animation019-modal"
          title={
            <div className="animation019-modal-header">
              <div className="animation019-modal-title">查看示例</div>
            </div>
          }
          footer={null}
          visible={isModalOpen}
          onCancel={() => setModalOpen(false)}
        >
          <img
            src={require(`../../../../../assets/${modalItem[0]?.img}`).default}
            alt=""
          />
        </Modal>
      )}
    </div>
  );
};

export default Animation019;
